import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';


import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CartaoCreditoService } from '../shared/services/cartao-credito.service';
import { CompraService } from '../shared/services/compra.service';
import { DadosUsuarioService } from '../shared/services/dados-usuario.service';
import { ProdutoSugerido } from '../shared/models/produto-sugerido.model';
import { IConfiguracao } from '../shared/models/configuracao.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { ComprarComponent } from '../layout/users-dashboard/dashboard-comprador/comprar/comprar.component';
import { UtilsCompraService } from '../shared/services/utils-compra.service';
import { ScrollService } from '../shared/services/scroll.service';
import { ICalculo } from '../shared/models/calculo.model';
import { CurrencyPipe } from '@angular/common';
import { CalculoService } from '../shared/services/calculo.service';
import dayjs from 'dayjs';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatDivider } from '@angular/material/divider';
import { LoaderComponent } from '../shared/loader/loader.component';

@Component({
    selector: 'app-carrinho',
    templateUrl: './carrinho.component.html',
    styleUrls: ['./carrinho.component.scss'],
    standalone: true,
    imports: [LoaderComponent, MatDialogTitle, MatDialogContent, MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgxMaskDirective, CurrencyPipe, TranslateModule]
})
export class CarrinhoComponent implements OnInit {

    produtoscarrinho: ProdutoSugerido[] = [];
    configuracao?: IConfiguracao;
    isSaving = false;
    isLoading = false;
    formContatoSend = false;
    isInDashboard =  false;
    contactForm = this.fb.group({
        id: [],
        nome: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        telefone: ['', Validators.required],
        cpfCnpj: [],
        calculo: [],
        observacao: [],
        dataAtualizacao: [],
        timestamp: [dayjs()],
        user: [],
    });

    constructor(
        private utilsCompraService: UtilsCompraService,
        private $localStorage: LocalStorageService,
        private $sessionStorage: SessionStorageService,
        protected currencyPipe: CurrencyPipe,
        protected cartaoCreditoService: CartaoCreditoService,
        protected activatedRoute: ActivatedRoute,
        protected comprarService: CompraService,
        protected cartaoService: CartaoCreditoService,
        protected router: Router,
        protected dadosUsuarioService: DadosUsuarioService,
        protected fb: FormBuilder,
        protected calculoService: CalculoService,
        public scrollService: ScrollService,
        public dialogRef: MatDialogRef<CarrinhoComponent>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: { calcProfile: string, custo?: number, quantidadeKg?: number, productTon?: number, typeProduct?: string },
    ) {

    }

    ngOnInit() {
        this.utilsCompraService.buscaDadosUsuario();
        this.utilsCompraService.loadConfigurations();
        this.configuracao = this.utilsCompraService.configuracao;
        this.isLoading = this.utilsCompraService.isLoading;
        this.produtoscarrinho = this.utilsCompraService.getCarrinho();
        this.isInDashboard = this.activatedRoute.snapshot['_routerState'].url.includes('calc-menu');
    }

    sendContatoForm() {
        this.formContatoSend = true;
    }

    totalCo2(): number {
        let total = 0;
        this.produtoscarrinho.forEach(e => {
            total += e.quantidadeKg * (e.quantidadeanos > 0 ? e.quantidadeanos : 1);
        })
        return total / 1000;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    valorTotalCarrinho() {
        let total = 0;
        this.produtoscarrinho.forEach(e => {
            total += e.valorTotal;
        })
        return total;
    }

    save() {
        if(!this.contactForm.valid){
            alert('Preencha os campos corretamente');
            return;
        }
        let calculo: ICalculo = this.contactForm.getRawValue();
        calculo.cpfCnpj = '';
        calculo.observacao = '';
        calculo.calculo = `Essa quantidade de ${this.currencyPipe.transform(this.data.quantidadeKg/1000, '', '', '1.0-2')} Ton de pegada de CO2e pode ser compensada no valor de ${this.currencyPipe.transform(this.data.custo, 'BRL')}
        ${this.calculatePerKg()? (' ou ' + this.currencyPipe.transform(this.calculatePerKg(), 'BRL') + '/' + this.isLitre()? 'L': 'kg') : ''}${this.data.typeProduct?(this.data.typeProduct === 'Peça'? ' por '+ this.data.typeProduct : ' de '+this.data.typeProduct): ''}.
          ${this.data.calcProfile? 'Esse calculo foi gerado utilizando a calculadora de '+ this.data.calcProfile: ''}`;
        this.isSaving = true;
        this.isLoading = true;
        this.calculoService.create(calculo).subscribe(
            () => {
                this.isSaving = false;
                this.isLoading = false;
                this.formContatoSend = true;
            },
            () => {
                this.isSaving = false;
                this.isLoading = false;
                this.formContatoSend = true;
                alert("erro ao enviar forms");
            }
        )
    }

    async deletar(itemIndex) {
        if (confirm("Deseja realmente excluir?")) {
            this.produtoscarrinho.splice(itemIndex, 1);
            this.utilsCompraService.saveToCart(this.produtoscarrinho);
        }
    }

    openDialogCompra(): void {
        this.onNoClick();
        if (this.utilsCompraService.errors != null) {
            alert('Crie uma conta ou faça o Login para finalizar a compra.');
            this.router.navigate(['./site/login']);
            return;
        }
        this.dialog.open(ComprarComponent, {
            data: { quantidadeKgCo2: this.totalCo2(), isFromCarrinho: true }
        }).afterClosed().subscribe(() =>
            this.router.navigate(['/dashboard-comprador']));
    }

    redirectToCalc() {
        this.onNoClick();
        if (this.utilsCompraService.errors != null) {
            // alert('Crie uma conta ou faça o Login para finalizar a compra.');
            this.router.navigate(['./site/calculadora-menu']);
            return;
        }
        this.router.navigate(['./calc-menu']);
    }

    isJuridica() {
        if (this.data.calcProfile === '' || this.data.calcProfile === null) {
            return false;
        }
        return true;
    }

    navitageToContato() {
        this.$sessionStorage.store("tonCO2", this.data.quantidadeKg/1000);
        this.$sessionStorage.store("valorCO2", this.data.custo);
        this.$sessionStorage.store("productType", this.data.typeProduct);
        this.$sessionStorage.store("perKg", this.calculatePerKg());
        this.$sessionStorage.store("calcProfile", this.data.calcProfile);
        this.onNoClick();
        this.router.navigate(['./site/faleconosco']);
        this.scrollService.scrollTop();
    }

    isLoggedIn() {
        if (this.isInDashboard === true) {
            this.formContatoSend = true;
            return true;
        }
        return false;
    }

    calculatePerKg() {
        let result = this.data.custo / this.data.productTon;
        if (this.isLitre() || this.data.typeProduct.includes('Peça')) {
            return result;
        }
        result = result / 1000;
        return result;
    }

    isLitre() {
        if (this.data.typeProduct === 'Suco natural de laranja') {
            return true;
        }
        return false;
    }

}
